import request from '@/utils/request';
// const perfix = ''

/**
 * 报表灰度
 * @param data
 */
export function cangrayscaleHotel() {
  return request({
    url: '/report/common/cangrayscale/hotel',
    method: 'get',
  });
}

export function exportOverDutyReport() {
  return;
}

export function overDutyReport() {
  return;
}

/**
 * 营业收入报表
 * @param data
 */
export function getOperatingIncome(data) {
  return request({
    url: '/fmis/report/businessIncome',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}
export function getReportOperatingIncome(data) {
  return request({
    url: '/report/management/report/businessIncome',
    method: 'get',
    params: data,
    notCheckRepeat: true,
  });
}

/**
 * 导出营业收入报表
 * @param data
 */
export function exportOperatingIncome(data) {
  return request({
    url: '/fmis/report/export/businessIncome',
    method: 'post',
    data,
  });
}
export function exportReportOperatingIncome(data) {
  return request({
    url: '/report/management/report/export/businessIncome',
    method: 'get',
    params: data,
  });
}

/**
 * 营业收入明细报表
 */
export function fetchBusinessIncomeDetail(params) {
  return request({
    url: '/report/management/report/businessIncomeDetail',
    method: 'get',
    params,
    notCheckRepeat: true,
  });
}

/**
 * 导出营业收入明细报表
 */
export function exportBusinessIncomeDetail(params) {
  return request({
    url: '/report/management/report/export/businessIncomeDetail',
    method: 'get',
    params,
    responseType: 'blob',
  });
}

/**
 * 现付账消费明细报表
 * @param data
 */
export function getPayExpense(data) {
  return request({
    url: '/report/income/cashPayDetail',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}

/**
 * 导出现付账消费明细报表
 * @param data
 */
export function exportPayExpense(data) {
  return request({
    url: '/report/income/export/cashPayDetail',
    method: 'post',
    responseType: 'blob',
    data,
  });
}
/**
 * AR账明细报表
 * @param data
 */
export function getAr(data) {
  return request({
    url: '/report/accout/channel/detail',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}

/**
 * 消费排名报表
 * @param data
 */
export function getSellRank(data) {
  return request({
    url: '/fmis/report/agreementCompanyReport',
    method: 'get',
    params: data,
  });
}

/**
 * 转账报表
 * @param data
 */
export function getTransferCash(data) {
  return request({
    url: '/fmis/report/transferAccountReport',
    method: 'get',
    params: data,
  });
}

/**
 * 冲账报表
 * @param data
 */
export function getRushCash(data) {
  return request({
    url: '/fmis/report/enterAccountReport',
    method: 'get',
    params: data,
  });
}

/**
 * 调账报表
 * @param data
 */
export function getAdjustmentCash(data) {
  return request({
    url: '/fmis/report/adjustAccountReport',
    method: 'get',
    params: data,
  });
}

/**
 * 导出AR账明细报表
 * @param data
 */
export function exportAr(data) {
  return request({
    url: '/report/accout/export/channel/detail',
    method: 'post',
    responseType: 'blob',
    data,
  });
}

/**
 * 导出消费排名报表
 * @param data
 */
export function exportSellRank(data) {
  return request({
    url: '/fmis/report/export/agreementCompanyReport',
    method: 'post',
    data,
  });
}

/**
 * 导出转账报表
 * @param data
 */
export function exportTransferCash(data) {
  return request({
    url: '/fmis/report/export/transferAccountReport',
    method: 'post',
    data,
  });
}

/**
 * 导出冲账报表
 * @param data
 */
export function exportRushCash(data) {
  return request({
    url: '/fmis/report/export/enterAccountReport',
    method: 'post',
    data,
  });
}

/**
 * 导出调账报表
 * @param data
 */
export function exportAdjustmentCash(data) {
  return request({
    url: '/fmis/report/export/adjustAccountReport',
    method: 'post',
    data,
  });
}

/**
 * 付款科目统计报表
 * @param data
 */
export function getPayment(data) {
  return request({
    url: '/report/management/report/paymentSubject',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}

/**
 * 导出付款科目统计报表
 * @param data
 */
export function exportPayment(data) {
  return request({
    url: '/report/management/report/paymentSubject/export',
    method: 'post',
    data,
  });
}

/**
 * 消费科目统计报表
 * @param data
 */
export function getExpense(data) {
  return request({
    url: '/fmis/report/consumeSubject',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}

/**
 * 导出付款科目统计报表
 * @param data
 */
export function exportExpense(data) {
  return request({
    url: '/fmis/report/export/consumeSubject',
    method: 'post',
    data,
  });
}
/**
 * 查询交班操作人信息
 * @param data
 */
export function fetchOperationInfoList(data) {
  return request({
    url: '/system/settings/base/business_day/shifts_operator/info',
    method: 'get',
    params: data,
  });
}
// 查询交接班报表
export function queryHandleOverData(params) {
  return request({
    url: '/report/management/report/shifts',
    method: 'post',
    data: params,
  });
}
// 导出交接班报表
export function exportHandleOverReport(params) {
  return request({
    url: '/report/management/report/shifts/export',
    method: 'post',
    responseType: 'blob',
    data: params,
  });
}
// 交班确认交班
export function handleOverOrConfirm({ id, ackStatus }) {
  return request({
    url: `/system/settings/base/shifts/report/${id}/status/${ackStatus}`,
    method: 'put',
  });
}

// 早餐详细列表
export function queryBreakfastDetailReport(params) {
  return request({
    url: '/fmis/report/queryBreakfastDetailReport',
    method: 'get',
    params,
  });
}

// 到处
export function exportBreakfastDetailReport(params) {
  return request({
    url: '/fmis/report/exportBreakfastDetailReport',
    method: 'get',
    params,
  });
}

/* 换房及房型升级报表
 * @param data
 */
export function changeHistoryReportForm(data) {
  return request({
    url: '/report/orderReport/changeHistoryReportForm',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}
/**
 * 导出换房及房型升级报表
 * @param data
 */
export function exportChangeHistoryReportForm(data) {
  return request({
    url: '/report/orderReport/exportChangeHistoryReportForm',
    method: 'post',
    data,
  });
}
/**
 * 在住客人余额表
 * @param data
 */
export function todayStayInBalanceReport(data) {
  return request({
    url: '/fmis/report/todayStayInBalanceReport',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}
/**
 * 导出在住客人余额表
 * @param data
 */
export function expoertTodayStayInBalanceReport(data) {
  return request({
    url: '/fmis/report/export/expoertTodayStayInBalanceReport',
    method: 'post',
    data,
  });
}
/**
 * 结账退房统计报表
 * @param data
 */
export function queryCheckOutReportForm(data) {
  return request({
    url: '/order/houseKeeper/queryCheckOutReportForm',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}
/**
 * 导出结账退房统计报表
 * @param data
 */
export function exportCheckOutReportForm(data) {
  return request({
    url: '/order/houseKeeper/exportCheckOutReportForm',
    method: 'post',
    responseType: 'blob',
    data,
  });
}
/**
 * 渠道消费排名报表
 * @param data
 */
export function channelConsumeReportForm(data) {
  return request({
    url: '/order/houseKeeper/channelConsumeReportForm',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}
/**
 * 导出渠道消费排名报表
 * @param data
 */
export function exportChannelConsumeReportForm(data) {
  return request({
    url: '/order/houseKeeper/exportChannelConsumeReportForm',
    method: 'post',
    data,
  });
}
/**
 * 收入汇总表
 * @param data
 */
export function incomeStatistics(data) {
  return request({
    url: '/fmis/report/incomeStatistics',
    method: 'get',
    params: data,
  });
}

/**
 * 导出A收入汇总表
 * @param data
 */
export function expoertIncomeStatistics(data) {
  return request({
    url: '/fmis/report/expoertIncomeStatistics',
    method: 'post',
    data,
  });
}

/**
 * 信用公司账龄报表
 * @param data
 */
export function createdCompanyAccountOfAge(data) {
  return request({
    url: '/fmis/verificateController/creditPage',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}

/**
 * 导出信用公司账龄报表
 * @param data
 */
export function exportCreatedCompanyAccountOfAge(data) {
  return request({
    url: '/fmis/verificateController/export/creditPage',
    method: 'post',
    responseType: 'blob',
    data,
  });
}

/**
 * 应收账--账套列表(根据hotelCode)枚举
 */
export function getReceiveAccountByHotelCode() {
  return request({
    url: '/fmis/receiveAccountController/receiveAccountByHotelcode',
    method: 'get',
  });
}

/**
 * 早餐统计列表
 * @param data
 */
export function breakfastStatistic(data) {
  return request({
    url: '/fmis/report/breakfastStatisticsPage',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}

/**
 * 导出早餐统计列表
 * @param data
 */
export function exportBreakfastStatistic(data) {
  return request({
    url: '/fmis/report/exportBreakfastStatistics',
    method: 'post',
    responseType: 'blob',
    data,
  });
}

// 早餐核销明细报表
export function queryBreakfastVerificateDetailReport(params) {
  return request({
    url: '/order/breakfast/verificate/record/list',
    method: 'get',
    params,
  });
}

// 导出早餐核销明细报表
export function exportBreakfastVerificateDetailReport(params) {
  return request({
    url: '/order/breakfast/verificate/record/export',
    method: 'get',
    params,
  });
}

/**
 * 零房费报表
 * @param data
 */
export function zeroRoomFee(data) {
  return request({
    url: '/report/quality/zeroRoomFreePage',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}

/**
 * 导出零房费报表
 * @param data
 */
export function exportZeroRoomFee(data) {
  return request({
    url: '/report/quality/zeroRoomFeePageExcel',
    method: 'post',
    responseType: 'blob',
    data,
  });
}

/**
 * 核销明细报表
 * @param data
 * @returns {AxiosPromise}
 */
export function redeemDetail(data) {
  return request({
    url: '/report/verificate/verificateRecordReport',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}

/**
 * 导出核销明细报表
 * @param data
 * @returns {AxiosPromise}
 */
export function exportRedeemDetail(data) {
  return request({
    url: '/report/verificate/exportVerficateRecord',
    method: 'post',
    responseType: 'blob',
    data,
  });
}

/**
 * 获取账套名称下拉列表
 * @returns {AxiosPromise}
 */
export function getAccountNameListForSelect() {
  return request({
    url: '/report/receiveAccount/queyAccountName',
    method: 'get',
  });
}

/**
 * 临时挂账报表
 * @param data
 * @returns {AxiosPromise}
 */
export function hangAccountReport(data) {
  return request({
    url: '/report/accout/hangAccountRepoert',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}

/**
 * 导出临时挂账报表
 * @param data
 * @returns {AxiosPromise}
 */
export function exportAccountReport(data) {
  return request({
    url: '/report/accout/exportAccountReport',
    method: 'post',
    responseType: 'blob',
    data,
  });
}

/**
 * 催账报表
 * @param data
 * @returns {AxiosPromise}
 */
export function demandAccountReport(data) {
  return request({
    url: '/report/quality/pushAccountPage',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}

/**
 * 导出催账报表
 * @param data
 * @returns {AxiosPromise}
 */
export function exportDemandAccountReport(data) {
  return request({
    url: '/report/quality/pushAccountExcel',
    method: 'post',
    responseType: 'blob',
    data,
  });
}

/**
 * 宾客住店报表
 * @param data
 * @returns {*}
 */
export function guestReport(data) {
  return request({
    url: '/report/orderReport/guestPage',
    method: 'post',
    data,
    notCheckRepeat: true,
  });
}

/**
 * 导出宾客住店报表
 * @param data
 * @returns {AxiosPromise}
 */
export function exportGuestReport(data) {
  return request({
    url: '/report/orderReport/export/guestReport',
    method: 'post',
    responseType: 'blob',
    data,
  });
}

/**
 * 房型枚举列表
 * @param flag boolean 是否显示无效房型
 * @returns {AxiosPromise}
 */
export function getRoomTypeSelectList(flag = true) {
  return request({
    url: '/report/common/queryRoomType',
    method: 'get',
    params: { flag },
  });
}
/**
 * 经营报表单日()
 * @param data
 */
export function manageSigle(data) {
  return request({
    url: '/fmis/management/report/managementReportSingle',
    method: 'get',
    params: data,
  });
}
export function reportManageSigle(data) {
  return request({
    url: '/report/management/report/managementReportSingle',
    method: 'get',
    params: data,
  });
}
/**
 * 导出经营报表单日
 * @param data
 */
export function exportManageSigle(data) {
  return request({
    url: '/fmis/management/report/downLoadManagementReportSingle',
    method: 'post',
    responseType: 'blob',
    data,
  });
}
export function exportReportManageSigle(data) {
  return request({
    url: '/report/management/report/downLoadManagementReportSingle',
    method: 'post',
    responseType: 'blob',
    data,
  });
}
/**
 * 经营报表累计
 * @param data
 */
export function manageTotal(data) {
  return request({
    url: '/fmis/management/report/managementGeneralLedger',
    method: 'get',
    params: data,
  });
}
export function reportManageTotal(data) {
  return request({
    url: '/report/management/report/managementGeneralLedger',
    method: 'get',
    params: data,
  });
}

/**
 * 导出经营报表累计
 * @param data
 */
export function exportManageTotal(data) {
  return request({
    url: '/fmis/management/report/downLoadManagementGeneralLedger',
    method: 'post',
    responseType: 'blob',
    data,
  });
}
export function exportReportManageTotal(data) {
  return request({
    url: '/report/management/report/downLoadManagementGeneralLedger',
    method: 'post',
    responseType: 'blob',
    data,
  });
}
// 小商品售卖汇总报表
export function fetchSmallwareSellSummaryReport(params) {
  return request({
    url: '/report/income/notionsCollectPage',
    method: 'post',
    data: params,
  });
}
// 小商品售卖汇总报表导出
export function exportSmallwareSellSummaryReport(params) {
  return request({
    url: '/report/income/notionsCollectExcel',
    method: 'post',
    responseType: 'blob',
    data: params,
  });
}
// 小商品售卖明细报表
export function fetchSmallwareSellDetailReport(params) {
  return request({
    url: '/report/income/notionsSalesDetailPage',
    method: 'post',
    data: params,
  });
}
// 小商品售卖明细报表导出
export function exportSmallwareSellDetailReport(params) {
  return request({
    url: '/report/income/notionsSalesDetailExcel',
    method: 'post',
    responseType: 'blob',
    data: params,
  });
}
// 客源入住明细报表
export function fetchGuestSourceDetailReport(params) {
  return request({
    url: '/report/management/report/customerSource',
    method: 'post',
    data: params,
  });
}
// 导出客源入住明细报表
export function exportGuestSourceDetailReport(params) {
  return request({
    url: '/report/management/report/export/customerSource',
    method: 'post',
    data: params,
    responseType: 'blob',
  });
}
// 预授权报表
export function preAuthReport(data) {
  return request({
    url: '/report/authorize/list',
    method: 'post',
    data,
  });
}
// 预授权报表导出
export function preAuthExport(data) {
  return request({
    url: '/report/authorize/list/export',
    method: 'post',
    data,
    responseType: 'blob',
  });
}
// 预授权报表
export function sellerReport(data) {
  return request({
    url: '/report/salesman/performance/detail',
    method: 'post',
    data,
  });
}
// 预授权报表导出
export function sellerExport(data) {
  return request({
    url: '/report/salesman/performance/export',
    method: 'post',
    data,
    responseType: 'blob',
  });
}

// 酒店销售报表查询
export function hotelSalesRoomReport(data) {
  return request({
    url: '/report/hotelSales/report/rooms',
    method: 'post',
    data,
  });
}

// 导出酒店销售报表
export function exportHotelSalesRoomReport(data) {
  return request({
    url: '/report/hotelSales/report/rooms/export',
    method: 'post',
    data,
    responseType: 'blob',
  });
}

/* 停用房报表
 * @param data
 */
export function repairReport(data) {
  return request({
    url: '/report/frontdesk/hotel/repairReport',
    method: 'post',
    data,
  });
}

/* 导出停用房报表
 * @param data
 */
export function exportRepairReport(data) {
  return request({
    url: '/report/frontdesk/hotel/exportRepairReport',
    method: 'post',
    data,
  });
}

/* 应收账龄表
 * @param data
 */
export function arAgeReport(data) {
  return request({
    url: '/report/verificate/arAgeSumUnverificate',
    method: 'post',
    data,
  });
}

/* 收入报表-底价报表
 * @param data
 */
export function queryOrderBasePriceReport(data) {
  return request({
    url: '/report/orderReport/queryOrderBasePriceReport',
    method: 'post',
    data,
  });
}

/* 收入报表-导出底价报表
 * @param data
 */
export function exportOrderBasePriceReport(data) {
  return request({
    url: '/report/orderReport/exportOrderBasePriceReport',
    method: 'post',
    data,
  });
}

// 线上支付对账
export function onlinePayRec(data) {
  return request({
    url: '/report/onlinePayRec/list',
    method: 'post',
    data,
  });
}

// 线上支付对账表导出
export function onlinePayRecExport(data) {
  return request({
    url: '/report/onlinePayRec/export',
    method: 'post',
    data,
    responseType: 'blob',
  });
}

// 查询客房打扫报表
export function roomCleanQueryList(params) {
  return request({
    url: '/system/settings/roomClean/queryList',
    method: 'get',
    params,
  });
}



/* 财务-出入库报表
 * @param data
 */
export function queryInventoryInOutReport(data) {
  return request({
    url: '/report/storage/storageReportQuery',
    method: 'post',
    data,
  });
}

/* 财务-出入库导出
 * @param data
 */
export function queryInventoryInOutReportExport(data) {
  return request({
    url: '/report/storage/storageReportExport',
    method: 'post',
    responseType: 'blob',
    data,
  });
}

/* 查询防飞房报表
 * @param data
 */
export function querySelfServiceReport(params) {
  return request({    
    url: '/report/hardwareRecord/querySelfServiceReport',
    method: 'get',
    params,
  });
}

/* 导出防飞房报表
 * @param data
 */
export function exportSelfServiceReport(params) {
  return request({    
    url: '/report/hardwareRecord/exportSelfServiceReport',
    method: 'get',
    params,
  });
}
